var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBackDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "13px",
    viewBox: "0 0 7 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "category-filtr--copy-3",
    transform: "translate(-499.000000, -505.000000)",
    fill: "#181515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(60.000000, 501.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1",
    transform: "translate(432.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1024464,13.796442 C9.8834188,13.796442 9.69440607,13.7177543 9.54027552,13.5644349 L4.39555996,8.41890816 C4.24954154,8.27451217 4.1627417,8.06440789 4.1627417,7.85673725 C4.1627417,7.63852084 4.24061819,7.44950811 4.39474875,7.29456634 C4.54644566,7.14449186 4.74600416,7.06174809 4.95773086,7.06174809 C5.17189121,7.06174809 5.37144971,7.14530307 5.5215242,7.29537756 L10.1024464,11.8762998 L14.6833686,7.29456634 C14.8334431,7.14530307 15.0330016,7.06174809 15.2463508,7.06174809 C15.4596999,7.06174809 15.6600696,7.14530307 15.8085217,7.29537756 C15.9585962,7.44464083 16.0413399,7.64419933 16.0413399,7.85673725 C16.0413399,8.06846396 15.9594074,8.26883367 15.8093329,8.41890816 L10.6646173,13.5636237 C10.5104868,13.7177543 10.3222853,13.796442 10.1024464,13.796442",
    transform: "translate(10.102041, 10.429095) rotate(-90.000000) translate(-10.102041, -10.429095) "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackDark);
export default __webpack_public_path__ + "static/media/ic_back_dark.7889a510.svg";
export { ForwardRef as ReactComponent };